import React, { useState } from "react";
import { useApi } from "../../utils/api";
import { useUserInfo } from "../../utils/user";
import { Grid2, Typography, Card, Button } from "@mui/material";

const CoachingSignUpCreateAccountLink = () => {
  const { createAccountLink } = useApi();
  const { stripeAccountId } = useUserInfo();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const handleCreateAccountLink = async () => {
    setIsLoading(true);
    const accountLink = await createAccountLink(stripeAccountId);
    if (!accountLink.url) {
      setError("Error creating account link. Please try again.");
    }
    window.location.href = accountLink.url;
    setIsLoading(false);
  };

  return (
    <Grid2 container justifyContent="center" sx={{ m: 4 }}>
      <Grid2 item lg={6} sm={12}>
        <Card sx={{ p: 3, mt: 4 }}>
          <Typography variant="h5" sx={{ mb: 3, textAlign: "center" }}>
            Setting Up Your Account
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, textAlign: "center" }}>
            Stripe Account was created successfully. Please complete the
            onboarding process to continue.
          </Typography>
          <Button
            variant="contained"
            onClick={handleCreateAccountLink}
            sx={{ mt: 2, display: "block", mx: "auto" }}
            loading={isLoading}
            disabled={isLoading}
          >
            Complete Stripe Onboarding
          </Button>
          {error && (
            <Typography color="error" sx={{ mb: 2 }}>
              {error}
            </Typography>
          )}
        </Card>
      </Grid2>
    </Grid2>
  );
};

export default CoachingSignUpCreateAccountLink;
